import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./index.scss";
import Header from "../../appLayout/header";

const SlideGenerale = ({
  headerBg = "bg-color", // background du header
  infos = [], // tableau d’objets pour la colonne gauche
  title = "",
  description = "",
  sectionClass = "consulting-section", // classe personnalisée
  bgColor = "",
  bgImage = "",
  heightBg = "", // image de fond dynamique // couleur ou classe de fond
}) => {
  return (
    <section
      className={`${sectionClass} ${bgColor} ${heightBg}`}
      style={{
        backgroundColor: "#000",
        backgroundImage: bgImage ? `url(${bgImage})` : undefined,
        backgroundRepeat: bgImage ? "no-repeat" : undefined,
        backgroundPosition: bgImage ? "center center" : undefined,
        backgroundSize: bgImage ? "cover" : undefined,
      }}>
      <Header stylebg={"bg-color"} />
      <div
        fluid
        className="px-md-5 h-75 d-flex justify-content-md-center container-slider justify-content-end px-0 ">
        <Row className="align-items-md-center justify-content-end w-100">
          {/* Colonne gauche dynamique */}
          <Col md={4} className="text-left-info">
            {infos.map((info, index) => (
              <div key={index} className="info-item">
                <span
                  dangerouslySetInnerHTML={{
                    __html: info.label,
                  }}
                />
                <h3
                  className="mt-md-4 mt-0"
                  dangerouslySetInnerHTML={{
                    __html: info.value,
                  }}
                />
              </div>
            ))}
          </Col>

          {/* Espace central (optionnel) */}
          <Col md={2}></Col>

          {/* Colonne droite */}
          <Col md={6} className="hero-content text-light">
            <div className="hero-text">
              {title && (
                <h2
                  dangerouslySetInnerHTML={{
                    __html: title,
                  }}
                />
              )}
              {description && (
                <p
                  dangerouslySetInnerHTML={{
                    __html: description,
                  }}>
                  {}
                </p>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default SlideGenerale;
